import React from 'react';
import { Container, Typography, Box, Divider } from '@mui/material';

// Helper function to bold section headings
function formatPolicy(text) {
  const headings = [
    'Return Policy',
    'Eligibility',
    'Return Process',
    'Return Shipping Costs',
    'Refund Policy',
    'Refund Process',
    'Partial Refunds',
    'Refunds for International Orders',
    'Refund Status',
    'Exchanges',
    'Damaged or Incorrect Items',
    'Contact Us'
  ];
  let formatted = text;
  headings.forEach(h => {
    const regex = new RegExp(`(^|\\n)(${h})`, 'g');
    formatted = formatted.replace(
      regex,
      `$1<span class="policy-heading">${h}</span>`
    );
  });
  return formatted;
}

const policyText =
`Eligibility
Most items are eligible for return within 5 days of delivery. To qualify for a return, the product must be unused, in its original condition, and include all original tags, labels, accessories, and packaging. Items that show signs of use, damage, or missing components may not be accepted for return or may be subject to a partial refund. Please note that certain categories such as perishable goods, personalized items, or final sale products may not be eligible for return. Always check the product description or contact our support team for specific return eligibility.

Return Process
To initiate a return, please reach out to our customer support team with your order details and reason for return. Once your request is reviewed and approved, we will provide you with step-by-step instructions on how to return the item. Make sure the item is securely packaged to avoid any damage during transit. After we receive the returned item, our team will inspect it to ensure it meets the return eligibility criteria. If approved, a refund will be processed to your original payment method within 5–7 business days. You will also receive a confirmation email once the refund has been initiated.
Return Shipping Costs
Return shipping is the customer’s responsibility unless the item is defective or the return is due to our error.
Partial Refunds
If an item is returned used, damaged, or not in its original condition, a partial refund may be given.
Refunds for International Orders
International refunds are processed in the original currency at the exchange rate from the time of purchase. We are not responsible for changes in exchange rates.
Refund Status
You’ll receive an email once your refund is processed. For any delays or questions, please contact our customer support team.
`

const ExchangePolicy = () => (
  <Container maxWidth="xl" sx={{ py: 4 }}>
    <Typography variant="h4" fontWeight={600} sx={{ mb: 2, fontFamily: 'Poppins' }}>
      Return & Refund Policy
    </Typography>
    <Divider sx={{ mb: 0 }} />
    <Box
      sx={{
        fontFamily: 'Poppins',
        fontSize: 15,
        color: '#222',
        lineHeight: 1.5,
        whiteSpace: 'pre-line'
      }}
      dangerouslySetInnerHTML={{
        __html: formatPolicy(policyText)
      }}
    />
    <style>
      {`
        .policy-heading {
          display: block;
          font-weight: bold;
          font-size: 1.08em;
          margin-top: 1.5em;
          margin-bottom: 0.5em;
        }
      `}
    </style>
  </Container>
);

export default ExchangePolicy;